import {
	API_ADMIN_GET_ALL_BOXES,
	API_ADMIN_GET_BOX,
	API_ADMIN_PATCH_BOX,
	API_ADMIN_POST_BOX,
	API_ADMIN_DELETE_BOX,
	RESET_BOX,
	SET_BOX,
	ADMIN_INIT_NEW_BOX,
	ADMIN_RESET_FOCUS_BOX,
} from "actions/box";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_ADMIN_GET_ALL_BOXES]: {
		default: "/admin/boxes",
		v2: "/boxes",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_BOX]: {
		default: (boxId) => `/admin/boxes/${boxId}`,
		v2: (boxId) => `/boxes/${boxId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_PATCH_BOX]: {
		default: (boxId) => `/admin/boxes/${boxId}`,
		v2: (boxId) => `/boxes/${boxId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_POST_BOX]: {
		default: "/admin/boxes",
		v2: "/boxes",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_DELETE_BOX]: {
		default: (boxId) => `/admin/boxes/${boxId}`,
		v2: (boxId) => `/boxes/${boxId}`,
		currentClient: DEFAULT_CLIENT,
	},
	// Legacy-only endpoint (not implemented in v7 backend yet)
	[RESET_BOX]: {
		default: "/users/center",
		v2: "/users/center",
		currentClient: DEFAULT_CLIENT,
	},
	// Legacy-only endpoint (not implemented in v7 backend yet)
	[SET_BOX]: {
		default: "/users/center",
		v2: "/users/center",
		currentClient: DEFAULT_CLIENT,
	},
};

export function adminGetAllBoxes() {
	const version = getVersion(API_ADMIN_GET_ALL_BOXES);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_GET_ALL_BOXES,
		payload: {
			request: {
				url,
			},
			client: version.currentClient,
		},
	};
}

export function adminGetBoxById(boxId) {
	const version = getVersion(API_ADMIN_GET_BOX);
	const url = typeof version.path === 'function' ? version.path(boxId) : version.path;
	return {
		type: API_ADMIN_GET_BOX,
		payload: {
			request: {
				url,
			},
			client: version.currentClient,
		},
	};
}

export function adminPatchBox(box) {
	const version = getVersion(API_ADMIN_PATCH_BOX);
	const url = typeof version.path === 'function' ? version.path(box.id) : version.path;
	return {
		type: API_ADMIN_PATCH_BOX,
		payload: {
			request: {
				url,
				method: "PATCH",
				data: box,
			},
			client: version.currentClient,
		},
	};
}

export function adminPostBox(box) {
	const version = getVersion(API_ADMIN_POST_BOX);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_ADMIN_POST_BOX,
		payload: {
			request: {
				url,
				method: "POST",
				data: box,
			},
			client: version.currentClient,
		},
	};
}

export function adminDeleteBox(boxId) {
	const version = getVersion(API_ADMIN_DELETE_BOX);
	const url = typeof version.path === 'function' ? version.path(boxId) : version.path;
	return {
		type: API_ADMIN_DELETE_BOX,
		payload: {
			request: {
				url,
				method: "delete",
			},
			client: version.currentClient,
		},
	};
}

export function resetCenterBox() {
	const version = getVersion(RESET_BOX);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: RESET_BOX,
		payload: {
			request: {
				url,
				method: "PATCH",
				data: null,
			},
			client: version.currentClient,
		},
	};
}

export function setCenterBox(center, box) {
	const version = getVersion(SET_BOX);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: SET_BOX,
		payload: {
			request: {
				url,
				method: "PATCH",
				data: { center, box },
			},
			client: version.currentClient,
		},
	};
}

export function initNewBox() {
	return {
		type: ADMIN_INIT_NEW_BOX,
	};
}

export function resetFocusBox() {
	return {
		type: ADMIN_RESET_FOCUS_BOX,
	};
}
